import {
	createStore
} from 'vuex'
import {
	naviData
} from "@/api/index.js"
import util from "@/util/getAllRouterFiles.js"
import children from "@/router/routerMeta.js"
import {
	ElMessage
} from 'element-plus'
import router from "@/router/index.js"

export default createStore({
	state: {
		loginStatus: {
			userName: "",
			password: "",
			sessionId: "",
			wsUserId: ""
		},
		currentChildRouterPath: "/home/firstPage",
		tabsStatus: {
			tabs: [],
			selectedTab: ""
		},
		naviData: [],
		loadding: false
	},
	mutations: {
		SET_LOGINSTATUS: (state, value) => {
			state.loginStatus = value
		},
		SET_CURRENTCHILDROUTERPATH: (state, value) => {
			state.currentChildRouterPath = value
		},
		SET_TABS: (state, value) => {
			state.tabsStatus.tabs = value
		},
		SET_SELECTEDTAB: (state, value) => {
			state.tabsStatus.selectedTab = value
		},
		SET_NAVIDATA: (state, value) => {
			state.naviData = value
		},
		SET_LOADDING: (state, value) => {
			state.loadding = value
		},
		SET_UPDATEPASSWORD: (state, value) => {
			state.loginStatus.password = value
		},
		SET_CLEARLOGIN: (state) => {
			state.loginStatus.userName = ""
			state.loginStatus.sessionId = ""
			state.loginStatus.password = ""
			state.loginStatus.wsUserId = ""
			// localStorage.setItem('sessionid','')
		}
	},
	actions: {
		set_loginStatus: ({
			commit
		}, value) => {
			localStorage.setItem('sessionId',value.sessionId)
			commit('SET_LOGINSTATUS', value)
		},
		set_currentChildRouterPath: ({
			commit
		}, value) => {
			commit('SET_CURRENTCHILDROUTERPATH', value)
		},
		set_tabs: ({
			commit
		}, value) => {
			if (value) {
				value.forEach(f => {
					f.icon = "el-icon-s-management"
				})
			}
			let index = value.findIndex(f => f.text == "首页")
			if (index >= 0) {
				value.splice(index, 1)
			}

			value.unshift({
				text: "首页",
				id: "firstPage",
				closable: false,
				path: "/home/firstPage",
				icon: "el-icon-s-home"
			})
			

			commit('SET_TABS', value)
		},
		set_selectedTab: ({
			commit
		}, value) => {

			let rawData = value || "/home/firstPage"

			commit('SET_SELECTEDTAB', rawData)
			commit('SET_CURRENTCHILDROUTERPATH', rawData)
		},
	 	set_naviData:  ({
			commit
		}) => {
		 	naviData().then(data => {
				if (data.code == 0) {
					console.log("rrrrr",data.data.children)
					// data.data.children[9].children = null
					// commit('SET_NAVIDATA', navList[0].children)
					commit('SET_NAVIDATA', data.data.children)
					let routers = util.routersArray(data.data.children)

					routers.forEach(f => {
						children.push(f)
					})

					children.push({
						name: "home_503",
						path: "noauth",
						component: () => import("@/pages/err_no_auth.vue")
					})

					children.push({
						name: "home_404",
						path: "*",
						component: () => import("@/pages/err_no_auth.vue")
					})

					let homeRouter = {
						name: "home",
						path: "/home",
						component: () => import("@/pages/main.vue"),
						children
					}
					//resetRouter()
					console.log('homeRouter：',homeRouter)
					router.addRoute(homeRouter)//动态注册路由

					//addOthersPage()

					router.push({
						path: "/home"
					})
					return Promise.resolve('成功')
				}else{
					ElMessage({
						message: data.message,
						type: "error"
					})
					return Promise.reject('失败')
				}
			})
		},
		set_loadding: ({
			commit
		}, value) => {
			commit('SET_LOADDING', value)
		},
		set_updatePassword: ({
			commit
		}, value) => {
			commit('SET_UPDATEPASSWORD', value)
		},
		set_clearLogin: ({
			commit
		}) => {
			commit('SET_CLEARLOGIN')
		},
		update_tabs: ({
			commit
		}, value) => {
			commit("SET_TABS", value)
		}
	},
	getters: {
		getUserName(state) {
			return state.loginStatus.userName
		},
		getSessionId(state) {
			return state.loginStatus.sessionId
		},
		getWsUserId(state) {
			return state.loginStatus.wsUserId
		},
		getPassword(state) {
			return state.loginStatus.password
		},
		getCurrentChildRouterPath(state) {
			return state.currentChildRouterPath == "/home/home_503" ? "/home" : state.currentChildRouterPath
		},
		getTabs(state) {
			return state.tabsStatus.tabs
		},
		getSelectedTab(state) {
			return state.tabsStatus.selectedTab
		},
		getNaviData(state) {
			return state.naviData
		},
		getLoaddingStatus(state) {
			return state.loadding
		}
	}
})
